import {
  TableCellProps,
  WbTagsArray,
  createActionsColumn,
} from '@agilelab/plugin-wb-platform';
import { TypeBadge } from '../../../Entity/TypeBadge';
import { SearchFlagBox } from '../../components/SearchFlagBox';
import { SearchSystemActionsMenu } from '../../components/SearchSystemActionsMenu';
import { DateCell, DescriptionCell, NameCell } from './SearchResultsTableCells';
import { Row } from './utils';

export const columns: Array<TableCellProps<Row>> = [
  {
    field: 'title',
    headerName: 'Name',
    width: 300,
    fieldRender: result => <NameCell searchResult={result} />,
  },
  {
    field: '_resolvedType',
    headerName: 'Type',
    width: 100,
    fieldRender: result => (
      <TypeBadge
        typeDisplayName={result._resolvedType}
        kind={result._computedInfo.kind}
      />
    ),
  },
  {
    field: 'description',
    headerName: 'Description',
    fieldRender: result => (
      <DescriptionCell title={result.description}>
        {result.description}
      </DescriptionCell>
    ),
  },
  {
    field: 'tags',
    headerName: 'Tags',
    fieldRender: result => <WbTagsArray tags={result.tags || []} />,
  },
  {
    field: 'publishedAt',
    headerName: 'Last Published',
    width: 150,
    fieldRender: result => {
      return <DateCell date={result.publishedAt} />;
    },
  },
  {
    // put 'key' as there is no flag field in Row but WbTable forces you to provide a field
    field: 'key' as keyof Row,
    headerName: 'Flag',
    width: 80,
    resizable: false,
    maxWidth: 80,
    minWidth: 80,
    fieldRender: result => {
      return (
        <SearchFlagBox iconStyle={{ fontSize: 20 }} externalId={result.id} />
      );
    },
  },
  createActionsColumn({
    renderActions: result => {
      return (
        result._computedInfo.kind === 'system' && (
          <SearchSystemActionsMenu
            inDataContractLineage={
              result._computedInfo.in_data_contract_lineage
            }
            dataProductId={result.documentId}
            size="small"
          />
        )
      );
    },
  }),
];
